import './LoginPage.css';

/* eslint-disable operator-linebreak */
/* eslint-disable jsx-quotes */
/* eslint-disable react/jsx-filename-extension */
import { Button } from '@mui/material';
import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import logo from '../assets/Sarge-Login-Logo.png';

function LoginPage() {
  const { instance } = useMsal();
  function clearAllCookies() {
    const cookies = document.cookie.split('; ');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    }
  }
  const handleLoginMsEntra = () => {
    localStorage.clear();
    sessionStorage.clear();
    clearAllCookies();
    instance.loginRedirect({ ...loginRequest, prompt: 'select_account' }).catch((error) => {
      console.error('Login failed:', error);
    });
  };
  return (
    <div className="login-container">
      <div className="login-box">
        <img
          src={logo}
          alt="Sarge-Logo"
          style={{ marginTop: '10px', height: '200px', width: 'auto' }}
        />
        <Button
          variant="contained"
          sx={{
            borderRadius: 1,
            textTransform: 'none',
            width: '100%',
            fontSize: 16,
            fontWeight: 'bold',
          }}
          color="success"
          onClick={() => {
            handleLoginMsEntra();
          }}
        >
          Login
        </Button>
        {process.env.REACT_APP_ENVIRONMENT === 'UAT' && (
          <h4 style={{ color: 'red', fontWeight: 'bold' }}>
            UAT ENVIRONMENT. Please contact&nbsp;
            <a
              href='https://teams.microsoft.com/l/channel/...'
              target='_blank'
              rel='noopener noreferrer'
            >
              WO Chatbot UAT Team
            </a>
            &nbsp;on Teams for any questions.
          </h4>
        )}
      </div>
    </div>
  );
}

export default LoginPage;
